import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

import Button from "@material-ui/core/Button";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },

  navigation: {
    display: "flex",
    justifyContent: "space-between",
    paddingBottom: theme.spacing(1),
  },

  navigationRtl: {
    flexDirection: "row-reverse",
  },

  startOverLabel: {
    textTransform: "uppercase",
    // color: theme.palette.primary.light,
  },

  leftArrowRtl: {
    order: 1,
  },

  rightArrowRtl: {
    order: -1,
  },
}));

const StepPanelButtonBar = ({
  submitActive = false,
  isUploading = false,
  onPrevious,
  onCancel,
  onNext,
  onSubmit,
}) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  return (
    <div className={classes.root}>
      <div
        className={clsx(classes.navigation, {
          [classes.navigationRtl]: i18n.dir() === "rtl",
        })}
      >
        <Button
          disabled={isUploading}
          variant="outlined"
          onClick={onPrevious}
          startIcon={<ArrowBackIcon />}
          classes={{
            startIcon: clsx({
              [classes.leftArrowRtl]: i18n.dir() === "rtl",
            }),
          }}
        >
          {t("step_bar_previous")}
        </Button>

        {onNext && (
          <Button
            aria-label="go to next submission page"
            disabled={isUploading}
            variant="contained"
            onClick={onNext}
            endIcon={<ArrowForwardIcon />}
            classes={{
              endIcon: clsx({
                [classes.rightArrowRtl]: i18n.dir() === "rtl",
              }),
            }}
          >
            {t("step_bar_next")}
          </Button>
        )}

        {onSubmit && (
          <Button
            disabled={!submitActive}
            variant="contained"
            onClick={onSubmit}
            endIcon={<ArrowForwardIcon />}
            classes={{
              endIcon: clsx({
                [classes.rightArrowRtl]: i18n.dir() === "rtl",
              }),
            }}
          >
            {t("step_bar_submit")}
          </Button>
        )}
      </div>
      <div>
        <Button
          aria-label="go to previous submission page"
          classes={{ label: classes.startOverLabel }}
          variant="text"
          onClick={onCancel}
        >
          {t("step_bar_start_over")}
        </Button>
      </div>
    </div>
  );
};

export default StepPanelButtonBar;
